import {Notification, Transition} from '@mantine/core';
import type React from 'react';
import {useEffect, useState} from 'react';
import type {Recruitment} from '../../../../core/repositories/recruitingInfoRepository';
import {NotificationContent} from './NotificationContent';

type Props = {
  companyLogoURL: string;
  companyName: string;
  recruitmentList: Recruitment[];
  hasEntryButton: boolean;
  mounted: boolean;
  close: () => void;
};

export const RecruitmentNotification: React.FC<Props> = ({
  companyLogoURL,
  companyName,
  recruitmentList,
  hasEntryButton,
  mounted,
  close,
}: Props) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  const bottomPositionSp = hasEntryButton ? 'bottom-[136px]' : 'bottom-[76px]';

  return (
    <Transition mounted={mounted} transition="fade" duration={500}>
      {(styles) => (
        <Notification
          id="recruitment_notification"
          className={`fixed transition-transform duration-300 before:bg-transparent pc:bottom-16 ${bottomPositionSp}`}
          onClose={close}
          style={styles}
        >
          <NotificationContent
            companyLogoURL={companyLogoURL}
            companyName={companyName}
            recruitmentList={recruitmentList}
          />
        </Notification>
      )}
    </Transition>
  );
};
